import PageFooter from "../../shared/app-shell/PageFooter";
import { selectedVesselDetailsAtom, themeAtom } from "../../shared/atoms";
import { Efficiency } from "../components/Efficiency";
import { PortConsumption } from "../components/PortConsumption";
import { RightshipRating } from "../components/RightshipRating";
import { SpeedAndConsumption } from "../components/SpeedAndConsumption";
import { useAtomValue } from "jotai";
import { twMerge } from "tailwind-merge";

export const PerformanceTab = () => {
  const data = useAtomValue(selectedVesselDetailsAtom);
  const theme = useAtomValue(themeAtom);

  return (
    <>
      <div className={twMerge("mb-4 rounded-lg p-4 shadow-md", theme.home.tailwind.backgound)}>
        <SpeedAndConsumption />
        <PortConsumption />
      </div>

      <Efficiency CII={data?.[0].CII} EEOI={data?.[0].EEOI} EEXI={data?.[0].EEXI} />

      {RightshipRating(data)}

      <PageFooter />
    </>
  );
};
